<mat-card
  class="card pb-2"
  [class.is-mobile]="isMobile"
>
  <mat-card-title>{{ title() }}</mat-card-title>
  <mat-card-content class="p-0">
    <div
      class="max-h-[472px] overflow-y-auto"
      [style.zoom]="zoom()"
    >
      <mat-table
        class="main-table w-full"
        [dataSource]="dataSource"
      >
        <ng-container matColumnDef="index">
          <mat-header-cell
            class="text-sm"
            *matHeaderCellDef
          > {{ isNetworkSwitch() ? 'Port' : 'Outlet' }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div
              class="port-number select-none"
              (click)="selectPort(element)"
              [class.archived]="element.childDevice.status === eEntityStatus.Archived"
              [class.cursor-pointer]="childList()?.length||0 > 1"
              [class.error]="element.childDevice.incidentCountBySeverity.critical"
              [class.good]="!element.childDevice.incidentCountBySeverity.critical && !element.childDevice.incidentCountBySeverity.major && !element.childDevice.incidentCountBySeverity.minor"
              [class.paused]="element.childDevice.status === eEntityStatus.Paused"
              [class.unplugged]="element.childDevice.status === eEntityStatus.Unplugged"
              [class.warning]="(element.childDevice.incidentCountBySeverity.major || element.childDevice.incidentCountBySeverity.minor) && !element.childDevice.incidentCountBySeverity.critical"
            >
              <span>{{ element.orderNumber }}</span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="poePower">
          <mat-header-cell *matHeaderCellDef>PoE Power
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container *ngTemplateOutlet="value; context: {
              attribute: element.childDevice.additionalAttributes.poePower,
            }" />
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="speed">
          <mat-header-cell *matHeaderCellDef>Speed</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container *ngTemplateOutlet="value; context: {
              attribute: element.childDevice.additionalAttributes.speed,
            }" />
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="profile">
          <mat-header-cell *matHeaderCellDef>Profile</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container *ngTemplateOutlet="value; context: {
              attribute: element.childDevice.additionalAttributes.profile,
            }" />
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="activity">
          <mat-header-cell *matHeaderCellDef>Activity</mat-header-cell>
          <mat-cell
            class="block"
            *matCellDef="let element"
          >
            <div class="w-full bg-ui-gray-350 h-1 rounded overflow-hidden mt-4">
              <div
                class="progress-bar h-full bg-ui-blue-50 transition-all duration-300"
                [style.width.%]="element.childDevice.activity.tx"
              >
              </div>
            </div>
            <div class="w-full bg-ui-gray-350 h-1 rounded overflow-hidden my-2">
              <div
                class="progress-bar h-full  bg-ui-green-light transition-all duration-300"
                [style.width.%]="element.childDevice.activity.rx"
              >
              </div>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="packetsTx">
          <mat-header-cell *matHeaderCellDef>Packets Tx</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span>{{ element.childDevice.additionalAttributes.packetsTx.value }}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="packetsRx">
          <mat-header-cell *matHeaderCellDef>Packets Rx</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span>{{ element.childDevice.additionalAttributes.packetsRx.value }}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="txRate">
          <mat-header-cell *matHeaderCellDef>Tx Rate</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container *ngTemplateOutlet="value; context: {
              class: 'text-ui-blue-50',
              attribute: element.childDevice.additionalAttributes.txRate
            }" />
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="rxRate">
          <mat-header-cell *matHeaderCellDef>Rx Rate</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container *ngTemplateOutlet="value; context: {
                class: 'text-ui-green-light',
                attribute: element.childDevice.additionalAttributes.rxRate
              }" />
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actionBar">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            @if (element.childDevice.status === eEntityStatus.Paused) {
              <i
                class="icon-play-16 action-icon"
                (click)="resumePort(element)"
                [matTooltip]="'Resume'"
                [showForClientAdmin]="true"
                avsRestrictedEl
              ></i>
            }

            @if (element.childDevice.status === eEntityStatus.Active) {
              <i
                class="icon-pause-16 action-icon"
                (click)="pausePort(element)"
                [matTooltip]="'Pause Port'"
                [showForClientAdmin]="true"
                avsRestrictedEl
              ></i>
            }
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="power">
          <mat-header-cell *matHeaderCellDef>Power</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span>{{ element.childDevice.additionalAttributes.power.value | avsFormatNumber }}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="voltage">
          <mat-header-cell *matHeaderCellDef>Voltage</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span>{{ element.childDevice.additionalAttributes.voltage.value | avsFormatNumber }}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="current">
          <mat-header-cell *matHeaderCellDef>Current</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span>{{ element.childDevice.additionalAttributes.current.value | avsFormatNumber }}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="consumption">
          <mat-header-cell *matHeaderCellDef>Consumption</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span>{{ element.childDevice.additionalAttributes.consumption.value | avsFormatNumber }}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="powerOn">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let element">
            @let powerOn = element.childDevice.additionalAttributes.powerOn.value;
            @let isActive = powerOn === true || powerOn === '1' || powerOn === 'true';

            <span [class.text-ui-green-light]="isActive">
              {{ isActive ? 'On' : 'Off' }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="empty">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element"></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" />
        <mat-row *matRowDef="let row; columns: displayedColumns" />
      </mat-table>
    </div>

    <app-table-zoom
      (zoomChanged)="zoom.set($event)"
      [tableId]="tableId"
    />
  </mat-card-content>
</mat-card>

<ng-template
  #value
  let-attribute="attribute"
  let-class="class"
>
  @if (attribute.value !== null && attribute.value !== undefined) {
    <span [class]="class">{{ attribute.value }}</span>
    @if (attribute.unitsOfMeasure | avsMeasurementUnitDisplay; as unit) {
      <span class="port-details-units">&nbsp;{{ unit }}</span>
    }
  } @else {
    -
  }
</ng-template>
